import SectionText from './component';
import withLazyLoading from '../../adapters/withLazyLoading';

export default withLazyLoading(SectionText);
